import paronApi from '@/utils/paron-api'
export default {
    getAllPartners() {
        return paronApi.get('partner/all')
    },

    getPartnerById(id) {
        return paronApi.get(`partner/${id}`)
    },

    createPartner(data) {
        return paronApi.post('partner/new', data)
    },

    editPartnerById(id, data) {
        return paronApi.post(`partner/${id}/edit`, data)
    },

    deletePartnerById(id) {
        return paronApi.delete(`partner/${id}`)
    },
    getPartnersByFilter(page, filter, sortOption, order, perPage = 10) {
        // the backend sorts partners through a `sort` body field ("title_ASC"), not query params
        const body = { ...filter }
        if (sortOption) {
            body.sort = `${sortOption}_${order || 'ASC'}`
        }
        return paronApi.post(`partner/filtered?page=${page || 1}&per_page=${perPage}`, body)
    },
    searchPartners(query) {
        return this.getPartnersByFilter(1, { partner: query }, null, null, 20).then(resp => resp.data.data)
    },
    toggleApproved(id) {
        return paronApi.post(`partner/${id}/toggleApprove`)
    },
    getAllCategories() {
        return paronApi.get('category/all')
    }

}
